/**
 * 枚举类：发货方式
 */
module.exports = {
    EXPRESS: {
        name: '快递配送',
        value: 10,
        type: 1,
    },
    EXTRACT: {
        name: '上门自提',
        value: 20,
        type: 2,
    }
};
